import { useTenant } from "hooks/settings";
import { Loaded, loadedEndpoint } from "models/loaded";
import {
  AlloySavingsPoint,
  SavingsTimeseriesPoint,
  useGetStrategyDashboardSavingsTimeseriesQuery,
} from "src/store/api/generatedApi";

export interface SavingsTabData {
  weekly: SavingsTimeseriesPoint[];
  monthly: SavingsTimeseriesPoint[];
  cumulativeSavings: number;
  alloyWeekly: AlloySavingsPoint[];
  alloyMonthly: AlloySavingsPoint[];
  cumulativeAlloySavings: number;
}

export const useStrategyDashboardSavings = (): Loaded<SavingsTabData> => {
  const loadedRawData = loadedEndpoint(
    useGetStrategyDashboardSavingsTimeseriesQuery({ tenantName: useTenant() })
  );
  if (loadedRawData.status === "success") {
    return {
      status: "success",
      data: {
        weekly: loadedRawData.data.weekly,
        monthly: loadedRawData.data.monthly,
        cumulativeSavings: loadedRawData.data.cumulative_savings,
        alloyWeekly: loadedRawData.data.alloy_weekly,
        alloyMonthly: loadedRawData.data.alloy_monthly,
        cumulativeAlloySavings: loadedRawData.data.cumulative_alloy_savings,
      },
      fetching: loadedRawData.fetching,
    };
  }
  return loadedRawData;
};
